import React, { PropsWithChildren } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import clsx from 'clsx'

interface ConfirmationPopupProps {
    title?: string
    onCancel?: () => void
    popupClassName?: string
    onConfirm(): void
    cancelButtonText?: string
    confirmButtonText: string
    confirmButtonClassName?: string
    disabled?: boolean
    cancelButtonIcon?: any
}

const ConfirmationPopup = (props: PropsWithChildren<ConfirmationPopupProps>) => {
    const {
        onCancel,
        popupClassName,
        onConfirm,
        title,
        children,
        cancelButtonText,
        confirmButtonText,
        confirmButtonClassName,
        disabled,
        cancelButtonIcon,
    } = props

    return (
        <div className={clsx('confirmation-popup', popupClassName && popupClassName)}>
            {title && <h3>{title}</h3>}
            {children}
            <div className="buttons">
                {cancelButtonText && onCancel && (
                    <Button
                        mainColor
                        type="secondary"
                        onClick={onCancel}
                        icon={cancelButtonIcon}
                        iconAltText={clsx(cancelButtonIcon && cancelButtonText)}
                    >
                        {cancelButtonText}
                    </Button>
                )}
                <Button
                    mainColor
                    type="primary"
                    onClick={onConfirm}
                    className={confirmButtonClassName}
                    disabled={!!disabled}
                >
                    {confirmButtonText}
                </Button>
            </div>
        </div>
    )
}

export default ConfirmationPopup
